import { stringify as stringifyQs } from "qs";
import urlJoin from "url-join";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  FiltersWithMultipleValues,
  Pagination,
  Search,
  Sort,
  TabActionDialog
} from "../types";

export const remittanceRunnerSectionUrl = "/remittance-runner";
export const remittanceRunnerListPath =
  remittanceRunnerSectionUrl + "/remittances";
export const remittanceRunnerToRemitPath =
  remittanceRunnerSectionUrl + "/to-remit";

export const remittanceRunnerPath = (id: string) =>
  urlJoin(remittanceRunnerListPath, id);

export const remittanceRunnerListUrl = (params?: any): string => {
  const remittanceRunnerList = remittanceRunnerListPath;
  if (params === undefined) {
    return remittanceRunnerList;
  } else {
    return urlJoin(remittanceRunnerListPath, "?" + stringifyQs(params));
  }
};

export const remittanceRunnerToRemitUrl = (params?: any): string => {
  const toRemit = remittanceRunnerToRemitPath;
  if (params === undefined) {
    return toRemit;
  } else {
    return urlJoin(toRemit, "?" + stringifyQs(params));
  }
};

export type RemittanceRunnerListUrlDialog =
  | "download"
  | "cancel"
  | TabActionDialog;

export enum RemittanceRunnerListUrlEnum {
  motherOrder = "motherOrder",
  status = "status",
  dateShipped = "dateShipped",
  dateShippedFrom = "dateShippedFrom",
  dateShippedTo = "dateShippedTo",
  dateCompleted = "dateCompleted",
  dateCompletedFrom = "dateCompletedFrom",
  dateCompletedTo = "dateCompletedTo",
  amount = "amount",
  remittanceId = "remittanceId",
  remittanceDate = "remittanceDate",
  remittanceDateFrom = "remittanceDateFrom",
  remittanceDateTo = "remittanceDateTo",
  remitterName = "remitterName",
  remitterFirstName = "remitterFirstName",
  remitterLastName = "remitterLastName",
  dispatcherName = "dispatcherName",
  dispatcherFirstName = "dispatcherFirstName",
  dispatcherLastName = "dispatcherLastName",
  riderName = "riderName",
  riderFirstName = "riderFirstName",
  riderLastName = "riderLastName",
  isPaymentCollected = "isPaymentCollected",
  createdDate = "createdDate",
  createdDateFrom = "createdDateFrom",
  createdDateTo = "createdDateTo",
  query = "query",
  hasReceipt = "hasReceipt"
}
export enum RemittanceRunnerListUrlFiltersWithMultipleValuesEnum {
  deliveryType = "deliveryType",
  mall = "mall",
  companyName = "companyName"
}
export enum RemittanceRunnerListUrlSortField {
  date = "date"
}

export type RemittanceRunnerListUrlSort = Sort<
  RemittanceRunnerListUrlSortField
>;
export type RemittanceRunnerListUrlFilters = Filters<
  RemittanceRunnerListUrlEnum
> &
  FiltersWithMultipleValues<
    RemittanceRunnerListUrlFiltersWithMultipleValuesEnum
  >;

export type RemittanceRunnerListUrlQueryParams = BulkAction &
  Dialog<RemittanceRunnerListUrlDialog> &
  RemittanceRunnerListUrlSort &
  RemittanceRunnerListUrlFilters &
  ActiveTab &
  Pagination & {
    mall?: string;
  } & Search &
  FiltersWithMultipleValues<
    RemittanceRunnerListUrlFiltersWithMultipleValuesEnum
  >;
